module.exports = __webpack_public_path__ + "assets/979b3417bebebe6840d6423a885ca8ea.mp4";